import script from "./HistoricalTradeNetworkCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricalTradeNetworkCard.vue?vue&type=script&setup=true&lang=js"

import "./HistoricalTradeNetworkCard.vue?vue&type=style&index=0&id=0d1cfc3a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1cfc3a"]])

export default __exports__